export default {
  title: "Pride365+",
  links: [
    {
      label: "Worksheet",
      link: "/worksheet",
    },
    {
      label: "Podcasts",
      link: "/podcasts",
    },
    {
      label: "Facts",
      link: "/fact-sheets",
    },
    {
      label: "How to be an ally",
      link: "/how-to-be-an-ally",
    },
    {
      label: "Resources",
      link: "/resource-guides",
    },
    ,
    {
      label: "Transgender support",
      link: "/transgender-support",
    },
    {
      label: "Terminology & pronouns",
      link: "/terminology-&-pronouns",
    },
    {
      label: "Poster & flyer",
      link: "/poster-&-flyer",
      smaller: true,
    },
    {
      label: "Email",
      link: "/emails",
      smaller: true,
    },
    {
      label: "Socials",
      link: "/media",
      smaller: true,
    },
  ],
};
